import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para todo tipo de deudas?',
    a: 'Funciona para la mayoría de las deudas civiles uruguayas: préstamos personales, tarjetas de crédito, deudas con bancos y financieras. No aplica para deudas con el Estado (BPS, DGI) ni para pensiones alimenticias.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís un email con el link de descarga. Accedés desde tu celular, tablet o computadora en menos de 5 minutos. Sin programas especiales — solo un lector PDF gratuito.'
  }, {
    q: '¿Qué lo diferencia de buscar información en internet?',
    a: 'El contenido online es genérico y no aplica a Uruguay. Este sistema está construido específicamente para las leyes uruguayas vigentes — con plantillas reales, checklists y protocolos listos para ejecutar hoy mismo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía sin preguntas. Si el material no cumple con lo prometido, te devolvemos el 100%. Escribinos a soporteavanzapro@gmail.com y lo resolvemos en 24 horas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 px-4 bg-brand-light" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl font-black text-white flex items-center justify-center gap-3" data-id="element-112">
            <HelpCircle className="w-8 h-8 text-gold" data-id="element-113" />
            Lo Que Más Nos Preguntan
          </h2>
        </div>

        <div className="space-y-4" data-id="element-114">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-dark border border-gold/20 rounded-xl overflow-hidden" data-id="element-115">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-116">
                <span className="font-bold text-white pr-4" data-id="element-117">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-118">
                  <ChevronDown className="w-5 h-5 text-gold shrink-0" data-id="element-119" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-120">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-121">
                    <div className="px-6 pb-5 text-cream/80 text-sm leading-relaxed border-t border-gold/10 pt-4" data-id="element-122">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}